import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Cadastro from './components/Cadastro';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/login/Login';
import Home from './screens/Home/Home';
import UserDashboard from './components/UserDashboard/UserDashboard';
import Contato from './components/Contato';
import Indicadores from './components/Indicadores';
import Planos from './components/Planos';
import Portfolio from './components/Portifolio';
import { useAuth } from './components/auth';

function App() {
  const { isAuthenticated, logout, user } = useAuth();

  const AdminRoute = ({ children }) =>
    isAuthenticated && user?.owner === 'admin'
      ? children
      : <Navigate to="/login" replace />;

  const UserRoute = ({ children }) =>
    isAuthenticated && user?.owner === 'user'
      ? children
      : <Navigate to="/login" replace />;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/cadastro" element={<Cadastro />} />
      <Route path="/login" element={<Login />} />
      <Route path="/planos" element={<Planos />} />
      <Route path="/indicadores" element={<Indicadores />} />
      <Route path="/portifolio" element={<Portfolio />} />
      <Route path="/portfolio" element={<Navigate to="/portifolio" replace />} />
      <Route path="/contato" element={<Contato />} />

      <Route
        path="/dashboard/*"
        element={
          <AdminRoute>
            <Dashboard logout={logout} />
          </AdminRoute>
        }
      />

      <Route
        path="/dashboard-cliente/*"
        element={
          <UserRoute>
            <UserDashboard userId={user?.id} />
          </UserRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
